import CountryConfig from "./Models/CountryConfig";
import { CountryEnum } from "./Models/CountryEnum";

export default class CountryConfigs {
    private static Default: CountryConfig = {
        name: "Other",
        nameInLocalLanguage: "Other",
        code: "",
        code3: "",
        enumValue: CountryEnum.Other,
        translationLocale: "en"
    };

    static Sweden: CountryConfig = {
        ...CountryConfigs.Default,
        name: "Sweden",
        nameInLocalLanguage: "Sverige",
        code: "SE",
        code3: "SWE",
        enumValue: CountryEnum.Sweden,
        translationLocale: "se"
    };

    static Norway: CountryConfig = {
        ...CountryConfigs.Default,
        name: "Norway",
        nameInLocalLanguage: "Norge",
        code: "NO",
        code3: "NOR",
        enumValue: CountryEnum.Norway,
        translationLocale: "no"
    };

    static Denmark: CountryConfig = {
        ...CountryConfigs.Default,
        name: "Denmark",
        nameInLocalLanguage: "Danmark",
        code: "DK",
        code3: "DNK",
        enumValue: CountryEnum.Denmark,
        translationLocale: "dk"
    };

    static Finland: CountryConfig = {
        ...CountryConfigs.Default,
        name: "Finland",
        nameInLocalLanguage: "Suomi",
        code: "FI",
        code3: "FIN",
        enumValue: CountryEnum.Finland,
        translationLocale: "fi"
    };

    static Other: CountryConfig = {
        ...CountryConfigs.Default,
    };

    static AllCountries: CountryConfig[] = [
        CountryConfigs.Sweden,
        CountryConfigs.Norway,
        CountryConfigs.Denmark,
        CountryConfigs.Finland,

        CountryConfigs.Other
    ];

    static getCountryByCode(code: string): CountryConfig {
        var result = this.AllCountries.find(c => c.code.toLowerCase() === code?.toLowerCase() || c.code3.toLowerCase() === code?.toLowerCase());
        return result ? result : CountryConfigs.Other;
    }

    static getCountryByEnum(enumValue: CountryEnum): CountryConfig {
        var result = this.AllCountries.find(c => c.enumValue === enumValue);
        return result ? result : CountryConfigs.Other;
    }
}